/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { useAppSelector } from '../../../../reducers';
import { loadInsightsByPeriod } from '../../../../slice/insightsSlice';
import { DataPeriods } from '../../../../types/universalTracker';
import { getPeriodName } from '../../../../utils/universalTracker';

interface PeriodDropdownProps {
  initiativeId: string;
  selectedPack: 'ctl' | 'sgx_metrics';
  period?: DataPeriods;
  portfolioId?: string;
}

export const PeriodDropdown = (props: PeriodDropdownProps) => {
  const { initiativeId, selectedPack, period, portfolioId } = props;

  const history = useHistory();
  const dispatch = useDispatch();

  const insightDataByPeriodState = useAppSelector(state => state.insightsData);
  const { cachedByPeriod = {}, cachedPeriod } = insightDataByPeriodState;

  const setUrlPeriod = (period: DataPeriods) => {
    const params = new URLSearchParams({ period: period });
    history.replace({ search: (params).toString() });
  }

  React.useEffect(() => {
    if (!initiativeId) {
      return
    }
    if (portfolioId) {
      dispatch(loadInsightsByPeriod(initiativeId, selectedPack, period, portfolioId));
    } else {
      dispatch(loadInsightsByPeriod(initiativeId, selectedPack, period));
    }
  }, [dispatch, initiativeId, selectedPack, period, portfolioId]);

  const selectedPeriod = cachedPeriod ?? period ?? DataPeriods.Yearly;

  return (
    <>
      <UncontrolledDropdown>
        <DropdownToggle className='text-truncate' color='transparent' outline caret>
          <span className='px-2'>{getPeriodName(selectedPeriod)}</span>
        </DropdownToggle>
        <DropdownMenu end>
          <DropdownItem active={selectedPeriod === DataPeriods.Yearly} disabled={!cachedByPeriod[DataPeriods.Yearly]} onClick={() => setUrlPeriod(DataPeriods.Yearly)}>
            Annual
          </DropdownItem>
          <DropdownItem active={selectedPeriod === DataPeriods.Quarterly} disabled={!cachedByPeriod[DataPeriods.Quarterly]} onClick={() => setUrlPeriod(DataPeriods.Quarterly)}>
            Quarterly
          </DropdownItem>
          <DropdownItem active={selectedPeriod === DataPeriods.Monthly} disabled={!cachedByPeriod[DataPeriods.Monthly]} onClick={() => setUrlPeriod(DataPeriods.Monthly)}>
            Monthly
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    </>
  );
}
